export const coursesBatchesList = "COURSES_BATCHES_LIST";
export const lessonsList = "LESSONS_LIST";
export const sessionsList = "SESSIONS_LIST";
// Admins and Super Admins
export const adminsCoursesAndBatches = "ADMINS_COURSES_AND_BATCHES";
export const adminsSessionsList = "ADMINS_SESSIONS_LIST";
export const attendanceList = "ATTENDANCE_LIST";
export const channelPartnerCoursesAndBatches = "CHANNEL_PARTNER_COURSES_AND_BATCHES";
export const channelPartnerSessionsWiseAttendanceList = "CHANNEL_PARTNER_SESSIONS_WISE_ATTENDANCE_LIST";